import PropTypes from 'prop-types';
import React, { useState } from 'react';

import { useAuth } from '../../lib/authContext';
import Logout from '../Logout';
import ProdigyLogo from '../ProdigyLogo/ProdigyLogo';

import SignOutModal from './SignOutModal';

import './index.scss';

const HeaderActions = ({ handleClick, userProfile }) => {
  return <Logout onClick={handleClick} userProfile={userProfile} />;
};

export const Header = () => {
  const [showModal, setShowModal] = useState(false);
  const { user } = useAuth();
  const { profile } = user;

  const doSignOut = () => setShowModal(true);
  const cancelSignOut = () => setShowModal(false);

  return (
    <>
      <SignOutModal visible={showModal} closeSignOutModal={cancelSignOut} />
      <div className="header">
        <a href={process.env.REACT_APP_PLATFORM_DASHBOARD} rel="noopener noreferrer">
          <ProdigyLogo />
        </a>

        <div className="header__options">
          <a
            className="header__contact-link"
            href={process.env.REACT_APP_GET_IN_TOUCH_URL}
            rel="noopener noreferrer"
            target="_blank"
          >
            Contact us
          </a>
          <HeaderActions handleClick={doSignOut} userProfile={profile} />
        </div>
      </div>
    </>
  );
};

HeaderActions.defaultProps = {
  userProfile: {},
};

HeaderActions.propTypes = {
  handleClick: PropTypes.func.isRequired,
  userProfile: PropTypes.shape({}),
};

export default Header;
